<template>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="width"
      :nudge-left="width"
      :max-width="maxWidth"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <!-- class="mx-2 mt-n12" -->
        <v-btn
          color="#1976d2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Filter 
        </v-btn>
      </template>

      <v-card style="padding: 20px; padding-top: 35px" :style="extendHeight">
        <date-range-picker class="flex-c calendars mb-5" @clicked="onSelectDates" @updateWidth="updateWidth" :isVisible="isVisible" :resetValues="resetAll"/>
        <category-filter class="flex-c mb-5" :label="category_label" v-model="category" :isMultiple="true" :resetValues="resetAll"/>
        <types-filter class="flex-c mb-5" :label="types_label" v-model="types" :resetValues="resetAll"/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="reset"
          >
            Reset
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="applyFilter"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
</template>
<script>
import CategoryFilter from "./CategoryFilter.vue"
import TypesFilter from "./TypeFilter.vue"
import DateRangePicker from "./DateFilter.vue";

export default {
    name: "filter",
    components: {
        CategoryFilter,
        TypesFilter,
        DateRangePicker
    },
    data() {
        return {
            extendHeight: "",
            search: "",
            isVisible: false,
            menu: false,
            width: 500,
            maxWidth: 500,
            category_label: "Categories",
            types_label:"Types",
            dateRange: {
              startDate: '',
              endDate: ''
            },
            category: [],
            types:[],
            resetAll: false,
            isReset: false,
        }
    },
    watch: {
      menu: {
        handler() {
          if(!this.menu && this.isReset)
            this.resetAll = !this.resetAll;
        }
      }
    },
    methods: {
      updateWidth(val) {
        if(val){
        this.width = 800
        this.maxWidth = 800
        this.extendHeight = "height: 350px"
        }
        else{
        this.width = 500
        this.maxWidth = 500
        this.extendHeight =""
        }
        this.isVisible = val;
      },
      onSelectDates(value){
        this.dateRange = value
      },
      reset(){
        this.isReset = true;
        this.dateRange =  {
          startDate: '',
          endDate: ''
        }
        this.category = [],
        this.types = []
        let body = {
          search: this.search,
          category: this.category,
          types: this.types,
          dateRange: this.dateRange
        }
        this.$emit('applyFilter', body)
        this.menu = false
      },
      applyFilter(){
        this.isReset = false;
        let body = {
          search: this.search,
          category: this.category,
          types: this.types,
          dateRange: this.dateRange
        }
        this.$emit('applyFilter', body)
        this.menu = false
      }
    }
}
</script>